var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.1293 2H7.9893C4.69768 2 2.0293 4.66838 2.0293 7.96V16.04C2.0293 19.3316 4.69768 22 7.9893 22H16.1293C19.4209 22 22.0893 19.3316 22.0893 16.04V7.96C22.0893 4.66838 19.4209 2 16.1293 2Z",
    fill: "url(#paint0_linear_406_14042)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0586 17.2198C11.8605 17.2172 11.6712 17.1373 11.5311 16.9973C11.391 16.8572 11.3112 16.6679 11.3086 16.4698V7.52979C11.3086 7.43129 11.328 7.33377 11.3657 7.24277C11.4034 7.15178 11.4586 7.0691 11.5283 6.99946C11.5979 6.92981 11.6806 6.87457 11.7716 6.83688C11.8626 6.79918 11.9601 6.77979 12.0586 6.77979C12.1571 6.77979 12.2546 6.79918 12.3456 6.83688C12.4366 6.87457 12.5193 6.92981 12.5889 6.99946C12.6586 7.0691 12.7138 7.15178 12.7515 7.24277C12.7892 7.33377 12.8086 7.43129 12.8086 7.52979V16.4698C12.806 16.6679 12.7262 16.8572 12.5861 16.9973C12.446 17.1373 12.2567 17.2172 12.0586 17.2198Z",
    fill: "url(#paint1_linear_406_14042)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43945 14.5702C6.24054 14.5702 6.04978 14.4912 5.90912 14.3505C5.76847 14.2099 5.68945 14.0191 5.68945 13.8202V10.1802C5.68945 9.98126 5.76847 9.7905 5.90912 9.64985C6.04978 9.50919 6.24054 9.43018 6.43945 9.43018C6.63837 9.43018 6.82913 9.50919 6.96978 9.64985C7.11044 9.7905 7.18945 9.98126 7.18945 10.1802V13.8202C7.18686 14.0183 7.10701 14.2075 6.96692 14.3476C6.82682 14.4877 6.63756 14.5676 6.43945 14.5702Z",
    fill: "url(#paint2_linear_406_14042)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6191 14.5702C17.4202 14.5702 17.2295 14.4912 17.0888 14.3505C16.9482 14.2099 16.8691 14.0191 16.8691 13.8202V10.1802C16.8691 9.98126 16.9482 9.7905 17.0888 9.64985C17.2295 9.50919 17.4202 9.43018 17.6191 9.43018C17.8181 9.43018 18.0088 9.50919 18.1495 9.64985C18.2901 9.7905 18.3691 9.98126 18.3691 10.1802V13.8202C18.3666 14.0183 18.2867 14.2075 18.1466 14.3476C18.0065 14.4877 17.8172 14.5676 17.6191 14.5702Z",
    fill: "url(#paint3_linear_406_14042)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_14042",
    x1: 2.0293,
    y1: 12,
    x2: 22.0893,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_14042",
    x1: 11.3086,
    y1: 11.9998,
    x2: 12.8086,
    y2: 11.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_14042",
    x1: 5.68945,
    y1: 12.0002,
    x2: 7.18945,
    y2: 12.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_406_14042",
    x1: 16.8691,
    y1: 12.0002,
    x2: 18.3691,
    y2: 12.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.f2ff3b5b9b0df8371fcbce6ff5d48587.svg";
export { ForwardRef as ReactComponent };